import Cookies from "js-cookie";
import { login, logout, getUserInfo, firmAuditStatus } from '@/api';
import { setToken, getToken, removeToken, setExpiresIn, getExpiresIn, removeExpiresIn } from '@/utils/auth';
import {  setPermissions, getPermissions, removePermissions } from '@/utils/auth';
import { setUserId, getUserId, removeUserId } from '@/utils/auth';
import { setUserName, getUserName, removeUserName } from '@/utils/auth';
import { setUserPhone, getUserPhone, removeUserPhone } from '@/utils/auth';
import { setPlatformRole, getPlatformRole, removePlatformRole } from '@/utils/auth';
import { setExaminationState, getExaminationState, removeExaminationState } from '@/utils/auth';
import { encryption } from '@/utils/crypto.js';


const user = {
  state: {
    token: getToken(),
    expires_in: getExpiresIn(),
    // 用户名称
    userName: getUserName(),
    // 用户ID
    userId: getUserId(),
    // 业务联系人电话
    userPhone: getUserPhone(),
    // 是否企业认证标识
    examination: getExaminationState(),
    // 控制按钮权限
    permissions: getPermissions() ? getPermissions().split(",") : [],
    //平台用户角色
    role: getPlatformRole() ? getPlatformRole().split(",") : []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time;
    },
    SET_NAME: (state, name) => {
      state.userName = name;
    },
    SET_USERID: (state, id) => {
      state.userId = id;
    },
    SET_USERPHONE: (state, phone) => {
      state.userPhone = phone;
    },
    SET_EXAMINATION: (state, status) => {
      state.examination = status;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_ROLE: (state, permissions) => {
      state.role = permissions
    },
    LOGOUT: (state) => {
      state.token = null;
      removeToken();
      state.expires_in = null;
      removeExpiresIn();
      state.userName = null;
      removeUserName();
      state.userId = null;
      removeUserId();
      state.userPhone = null;
      removeUserPhone();
      state.examination = null;
      removeExaminationState();
      state.permissions = null;
      removePermissions();
      state.role = null;
      removePlatformRole();
      localStorage.removeItem('countDownTime');
      localStorage.removeItem('loginTimestamp');
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const user = encryption({
        data: userInfo,
        key: 'GJMC,FromWanQiao',
        param: ['password']
      });
      const phone = userInfo.phone.trim();
      const password = user.password;
      const verificationCode = userInfo.verificationCode;
      return new Promise((resolve, reject) => {
        login(phone, password, verificationCode).then(res => {
          let data = res.data;
          setToken(data.access_token);
          commit('SET_TOKEN', data.access_token);
          setUserName(data.name);
          commit('SET_NAME', data.name);
          setExpiresIn(data.expires_in);
          commit('SET_EXPIRES_IN', data.expires_in);
          setPermissions(data.permissions);
          commit('SET_PERMISSIONS',data.permissions);
          setPlatformRole(data.role);
          commit('SET_ROLE',data.role);
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          let data = res.data;
          setUserId(data.accountId);
          commit('SET_USERID', data.accountId);
          setUserPhone(data.businessContactPhone);
          commit('SET_USERPHONE', data.businessContactPhone);
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },

    // 获取企业认证状态
    GetAuthenticateState({ commit, state }) {
      return new Promise((resolve, reject) => {
        firmAuditStatus().then(res => {
          let data = res.data;
          if (data == null) {
            setExaminationState(null);
            commit('SET_EXAMINATION', null);
          } else {
            setExaminationState(data.checkFlag);
            commit('SET_EXAMINATION', data.checkFlag);
          }
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },
    // 退出系统并返回首页
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('LOGOUT');
          location.href = '/home/index';
          resolve();
        }).catch(error => {
          reject(error);
        })
      })
    },
    // 仅退出系统
    LogOutOnly({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('LOGOUT');
          resolve();
        }).catch(error => {
          reject(error);
        })
      })
    },

  }
}

export default user
